/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello World 👋",
  title2: "Vishnu V S",
  logo_name: "</>",
  nickname: "vishnu",
  full_name: "Vishnu V S",
  subTitle:
    "DevOps Engineer, A Developer turned DevOps Engineer with a passion for automating everything🔥",
  resumeLink:
    "https://drive.google.com/file/d/18itiYSgHfeKPdF9io6vTswE8wPB1Z02l/view",
  mail: "mailto:vishnuvs769@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/vishnuvs369",
  linkedin: "https://www.linkedin.com/in/vishnu-v-s-a74699163/",
  gmail: "vishnuvs769@gmail.com",
  twitter: "https://twitter.com/iamvishnuvs",
  instagram: "https://www.instagram.com/vishnuvs.in/",
};

const skills = {
  data: [
    {
      title: "DevOps Engineering",
      fileName: "FullStackImg",
      skills: [
        "⚡ Providing DevOps support to development teams and maintaining reliable, scalable infrastructure",
        "⚡ Automating infrastructure provisioning with Terraform & Ansible",
        "⚡ Designing and maintaining CI/CD pipelines using Jenkins, GitHub Actions & GitLab CI",
        "⚡ Containerization & orchestration using Docker & Kubernetes",
        "⚡ Monitoring & logging with Prometheus, Grafana, ELK Stack & Zabbix",
        "⚡ Configuration management using Ansible, Chef & Puppet",
        "⚡ Cloud infrastructure experience with AWS, GCP, and Azure",
        "⚡ Hands-on experience with Helm for Kubernetes application packaging",
        "⚡ Strong scripting & automation using Bash & Python",
      ],
      softwareSkills: [
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          style: {
            color: "#D24939",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "ElectronJS",
          fontAwesomeClassname: "simple-icons:electron",
          style: {
            color: "#47848F",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon-plain:java-wordmark",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
        "⚡ Experience with Continuous Integration & Deployment (CI/CD) for cloud environments",
        "⚡ Implementing Infrastructure as Code (IaC) using Terraform & CloudFormation",
        "⚡ Managing cloud networking, VPCs, and security groups",
        "⚡ Cloud storage and database management (S3, RDS, DynamoDB, Cloud SQL)",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "AZURE",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0078D4",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Cloudflare",
          fontAwesomeClassname: "simple-icons:cloudflare",
          style: {
            color: "#F38020",
          },
        },

        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "College of engineering Vadakara Under CUSAT",
      subtitle: "Bachelor of Technology in Computer Science & Engineering",
      logo_path: "cusat.png",
      alt_name: "CUSAT",
      duration: "2014 - 2018",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, Algorithms, Operating Systems, Computer Networks, and Databases.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
        "⚡ Participated in college technical events, coding competitions, and project presentations.",
      ],
      website_link: "https://www.cev.ac.in/en/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "GCCEP",
      subtitle: "Gremlin Chaos Engineering Practitioner Certificate",
      logo_path: "Gremlin.png",
      certificate_link:
        "https://www.credential.net/9655946d-4ac2-48e3-9b2e-b1d985de96be",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "white",
    },

    {
      title: "Core Java Certification",
      subtitle: "Jspiders Bengaluru",
      logo_path: "corejava.png",
      //certificate_link:
      // "https://drive.google.com/file/d/12se6bMep48WXA1PlizTBAgCnW0GXM6wq/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "orange",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "As a DevOps Engineer, I have been working on real-world projects for over four years. I have experience managing and automating infrastructure, CI/CD pipelines, and monitoring solutions. Most of my projects involve working independently, ensuring seamless deployments, and optimizing cloud-based environments. I also enjoy organizing DevOps meetups and knowledge-sharing sessions to help others learn best practices in automation and cloud computing.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "DevOps Engineer",
          company: "Netstratum Technologie Pvt. Ltd.",
          company_url: "https://netstratum.com/",
          logo_path: "netstratum.png",
          duration: "Dec 2021 - Present",
          location: "Kochi, Kerala",
          description: [
            "Ensured a reliable and scalable software infrastructure by providing DevOps support.",
            "Automated CI/CD for Web, Desktop, and Mobile apps using Jenkins, cutting deployment time by 60%.",
            "Managed Kubernetes clusters and CloudStack VMs, optimizing resource use.",
            "Orchestrated Docker container deployments via Kubernetes for high availability.",
            "Automated infrastructure provisioning with SaltStack.",
            "Leveraged AWS (EC2, S3, RDS, VPC) for scalable deployments.",
            "Integrated Azure DevOps pipelines with AWS EKS for automated Dockerized deployments.",
            "Installed and configured SonarQube with Jenkins for continuous code quality checks.",
            "Monitored servers and networks across data centers using Zabbix, Icinga, and Grafana.",
            "Deployed Kafka clusters with MirrorMaker 2 for multi-cluster replication.",
            "Configured Nginx and SSL for secure web services.",
            "Ensured timely SSL renewals.",
            "Researched and implemented open-source tools to improve software delivery.",
          ],
          color: "#0071C5",
        },

        {
          title: "DevOps Engineer (Freelancer)",
          company: "TGS",
          company_url: "http://nightowls.company/",
          logo_path: "tgs.jpg",
          duration: "Apr 2020 - Dec 2021",
          location: "Work From Home",
          description: [
            "Executed DevOps operations at Tapasya Global Solutions.",
            "Automated AWS workflows using Step Functions.",
            "Developed AWS Lambda and Step Functions to interact with S3.",
            "Built Python-based Lambda functions with Boto3 for JSON validation.",
            "Configured S3 triggers to invoke Lambda on JSON file uploads.",
            "Deployed AWS Lambda functions using the Serverless Framework.",
          ],
          color: "#ee3c26",
        },

        {
          title: "Backend Developer",
          company: "dWise Healthcare IT Solutions Pvt. Ltd",
          company_url: "https://www.lifetrenz.com/",
          logo_path: "dwise.jpg",
          duration: "Oct 2019 - Mar 2020",
          location: "Hybrid",
          description: [
            "Worked as a backend application developer",
            "Enhanced the AsterDM medical application for patient enrollment by updating backend services.",
            "Modified patient profile database to include Aadhaar and voter details.",
            "Developed PHP services to integrate PostgreSQL functions, and updated insurance modules to support new policies.",
          ],

          color: "#ee3c26",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects leverage a wide range of modern technology tools, with a strong focus on Cloud and DevOps. I’ve worked on infrastructure automation, CI/CD pipelines, containerization using Docker, Kubernetes orchestration, and cloud services like AWS. These projects reflect my interest in building scalable, automated, and reliable systems. Below are some of my projects. Note that not all of the mentioned projects are available on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Medium.com",
    link: "https://medium.com/@vishnuvs769",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "DevOps Suite",
      url: "https://devops-suite.online/",
      description:
        "DevOps Suite is a free online collection of DevOps tools and developer utilities for engineers: SSL and DNS checks, CIDR calculations, WHOIS lookup, port testing and more.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
      links: [
        {
          name: "Live URL",
          url: "https://devops-suite.online/",
          iconifyClass: "ri:global-line",
        },
      ],
    },
    {
      id: "1",
      name: "Spring Boot Login Registration",
      url: "https://github.com/vishnuvs369/springboot-loginregistration",
      description:
        "A secure user authentication system built with Spring Boot, featuring registration, login, and role-based access control with JWT authentication and database integration.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/vishnuvs369/springboot-loginregistration",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "2",
      name: "Blog Website",
      url: "https://github.com/vishnuvs369/Laravel-BlogWebsite",
      description:
        "A dynamic blog website built with PHP Laravel and MySQL, allowing users to create, edit, and manage blog posts.",
      languages: [
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "Mysql",
          iconifyClass: "logos-mysql",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/vishnuvs369/Laravel-BlogWebsite",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "3",
      name: "Blood Donation App",
      url: "https://github.com/vishnuvs369/Flutter-Blood-Donation-App",
      description:
        "A Flutter-based mobile application that connects blood donors with recipients in real-time. Built with a MySQL backend.",
      languages: [
        {
          name: "Flutter",
          iconifyClass: "logos-flutter",
        },
        {
          name: "dart",
          iconifyClass: "logos-dart",
        },
        {
          name: "restapi",
          iconifyClass: "logos-restapi",
        },
        {
          name: "mysql",
          iconifyClass: "logos-mysql",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/vishnuvs369/Flutter-Blood-Donation-App",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "4",
      name: "Maven Jenkins Build",
      url: "https://github.com/vishnuvs369/Maven-Jenkin-Demo",
      description:
        "This is Jenkins build pipeline for Maven spring boot application",
      languages: [
        {
          name: "Jenkins",
          iconifyClass: "logos-jenkins",
        },
        {
          name: "Maven",
          iconifyClass: "logos-maven",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/vishnuvs369/Maven-Jenkin-Demo",
          iconifyClass: "ri:github-fill",
        },
      ],
    },

    {
      id: "5",
      name: "Python Web Application",
      url: "https://github.com/vishnuvs369/python-mysql-crud-webapplication",
      description:
        "This is a simple python webapplication connecting to Mysql database",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Mysql",
          iconifyClass: "logos-mysql",
        },
      ],
      links: [
        {
          name: "Github",
          url:
            "https://github.com/vishnuvs369/python-mysql-crud-webapplication",
          iconifyClass: "ri:github-fill",
        },
      ],
    },

    {
      id: "6",
      name: "COVID-19 Tracker",
      url: "https://github.com/vishnuvs369/Covid19TrackerReact",
      description:
        "Simple Covid-19 Tracker made using React and deployed to Vercel.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/vishnuvs369/Covid19TrackerReact",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
